import angular from 'angular';
import './rolesServices';

/**
 * @ngdoc overview
 * @name superuserModule.rolesControllers
 * @description
 * # superuserModule.rolesControllers
 * Module for managing the controllers of: roles.
 */
const rolesControllers = angular.module('superuserModule.rolesControllers', ['superuserModule.rolesServices']);

/**
 * @ngdoc controller
 * @name superuserModule.rolesControllers.controller:RolesListController
 * @description
 * Controller for the list of roles
 */
rolesControllers.controller('RolesListController', ['$scope', 'NgTableParams', 'Role', 'AppsoupAPI', function ($scope, NgTableParams, Role, AppsoupAPI) {
    'use strict';

    $scope.search = {};

    $scope.tableParams = new NgTableParams(AppsoupAPI.getIdTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Role.getList(params && params._params ? params._params : {})
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);
                    return response;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.searchRoles = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };
}]);

/**
 * @ngdoc controller
 * @name superuserModule.rolesControllers.controller:RolePageController
 * @description
 * Controller for the specific roles
 */
rolesControllers.controller('RolePageController', ['$scope', '$rootScope', '$state', '$stateParams', '$translate', 'growl', 'Role', 'SystemModules', function ($scope, $rootScope, $state, $stateParams, $translate, growl, Role, SystemModules) {
    'use strict';

    const roleId = $stateParams.roleId;

    const goToRolesList = () => {
        $state.go('appsoup.admin.roles');
    };

    $scope.module = {};

    if (angular.isDefinedNotEmpty(roleId)) {
        $scope.editMode = true;

        $rootScope.doingResolve = true;
        Role.get(roleId).then((response) => {
            const data = response.data;

            if (data.success) {
                const role = data.role;
                $scope.role = {id: role.id, name: role.name, external_id: role.external_id};
                $scope.module = SystemModules.getReadWriteModules(role);
            } else if (angular.isDefined(data.error)) {
                growl.error(`MODULES.ROLES.${data.error}`);
                if (data.error === 'ERROR.NO_RESOURCE') {
                    goToRolesList();
                }
            }
        })
            .finally(() => {
                $rootScope.doingResolve = false;
            });
    } else {
        $scope.module = SystemModules.getReadWriteModules({});
    }

    $scope.saveRole = () => {
        $scope.$broadcast('show-errors-check-validity');

        if (angular.isDefined($scope.module) && SystemModules.countPermissions($scope.module) > 0 && $scope.roleForm.$valid) {
            $scope.isLoading = true;
            $scope.role = angular.extend($scope.role, SystemModules.getPermissions($scope.module));

            Role.save($scope.role, $scope.editMode)
                .then((data) => {
                    if (data.success) {
                        goToRolesList();
                        growl.success(`MODULES.ROLES.SUCCESS.${$scope.editMode ? 'EDIT' : 'NEW'}`);
                    } else {
                        $scope.formErrors = data.error;
                    }
                })
                .finally(() => {
                    $scope.isLoading = false;
                });
        } else {
            growl.error($translate.instant('MODULES.ROLES.ERROR.NOT_CHOSEN'), {referenceId: 1});
        }
    };

    $scope.deleteRole = () => {
        $scope.isDeleting = true;
        Role.remove($scope.role.id)
            .then((data) => {
                if (data.success) {
                    goToRolesList();
                    growl.success('MODULES.ROLES.SUCCESS.DELETE');
                }
            })
            .finally(() => {
                $scope.isDeleting = false;
            });
    };

    $scope.cancel = () => {
        goToRolesList();
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}]
    };

    Role.getShopIds().then((response) => {
        const data = response.data;
        if (data.success) {
            $scope.shopIds = data.shopIds;
        }
    });
}]);

export default rolesControllers;
